import {openDialog} from 'platform/components';

import {EntityResourceIds} from '@dms/api/shared';
import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

import {CustomNoticeDialog} from '../components/CustomNoticeDialog/CustomNoticeDialog';

interface OpenCreateCustomNoticeDialogProps extends TestIdProps {
  resourceId: EntityResourceIds;
  recordId: string;
}

export function openCreateCustomNoticeDialog(props: OpenCreateCustomNoticeDialogProps) {
  openDialog(
    <CustomNoticeDialog
      mode="create"
      resourceId={props.resourceId}
      recordId={props.recordId}
      data-testid={suffixTestId('createCustomNotice', props)}
    />,
    {
      title: i18n.t('general.customNotices.actions.create'),
      size: 'small',
      scrollBehavior: 'outside',
      'data-testid': suffixTestId('createCustomNotice', props),
    }
  );
}
